import type { GetProductionRecordsRequest, ProductionRecord } from "../../../domain/types/production-record";
import type { CompanyProductionRecordRepository } from "../../../domain/repositories/company/company-production-record-repository";
import type { PageResponse } from "../../../shared/types/common";
import { companyProductionRecordApiService } from "../../api/company/company-production-record-api-service";

export class CompanyProductionRecordRepositoryImpl implements CompanyProductionRecordRepository {
  async getProductionRecords(request: GetProductionRecordsRequest): Promise<PageResponse<ProductionRecord>> {
    const response = await companyProductionRecordApiService.getProductionRecords(request);

    if (response.data) {
      return response.data;
    }

    throw new Error(response.errorMsg || "생산 실적 조회 실패");
  }
}
